function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14",
  height: "14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7 .333C3.333.333.333 3.333.333 7s3 6.667 6.667 6.667 6.667-3 6.667-6.667S10.667.333 7 .333zM9.8 9.8L6.333 7.667v-4h1v3.466l3 1.8L9.8 9.8z",
  fill: "#54585D",
  fillOpacity: ".6"
})));